import { FunctionComponent, useCallback } from 'react'
import styled, { css } from 'styled-components'
import { SwisslosProps } from '@widgets/Teaser/toi/Sporttip/types'
import { desktopCSS } from '@measures/responsive'
import Blink from '@components/Blink'
import sporttipBetLogo from '@assets/images/logo-sporttip_bet.png'
import useTracking, { TrackingFnType } from '@hooks/useTracking'
import useViewportTracking from '@hooks/useViewportTracking'

const StyledSwisslos = styled(Blink)`
  ${({
    theme: {
      colors: {
        grey: { grey_100 },
      },
    },
  }) => css`
    margin-top: 2px;
    width: 100%;
    background-color: ${grey_100};
    display: grid;
    align-items: center;
    justify-items: center;
    ${desktopCSS(css`
      display: none;
    `)}
  `}
`

const StyledImage = styled.img`
  width: 180px;
  height: 54px;
  padding: 5px;
`

const Swisslos: FunctionComponent<SwisslosProps> = ({
  clickablePropsForSwisslos,
}) => {
  const onImpression = useCallback<TrackingFnType>(
    ({ pageMetadata: { title } }) => ({
      event: 'sporttip_impression',
      eventCategory: 'sporttip_widget',
      eventAction: 'impression',
      eventLabel: `${title}`,
    }),
    []
  )

  const onClick = useCallback<TrackingFnType>(
    ({ pageMetadata: { title } }) => ({
      event: 'sporttip_click',
      eventCategory: 'sporttip_widget',
      eventAction: 'click',
      eventLabel: `${title}`,
    }),
    []
  )

  const trackedOnImpression = useTracking(onImpression)
  const trackedOnClick = useTracking(onClick)

  const viewportRef = useViewportTracking({
    track: true,
    onImpression: trackedOnImpression,
  })

  return (
    <StyledSwisslos
      {...clickablePropsForSwisslos}
      ref={viewportRef}
      onClick={trackedOnClick}>
      <StyledImage
        src={sporttipBetLogo}
        alt="Swisslos logo"
        width="180"
        height="54"
        loading="lazy"
      />
    </StyledSwisslos>
  )
}

export default Swisslos
